import { Component, ElementRef, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { DeviceUuidService } from 'src/app/shared/services/deviceuuidservices/device-uuid.service';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
})
export class NotificationsComponent implements OnInit, AfterViewInit {
  public showSpinner = true;
  notifylist: any;
  totalCount: any;
  notify_counts: any;
  notifyData: any;
  filteredleaves: any;
  filteredAttendance: any;
  filteredLoans: any;
  user: any;
  showAdmintab = false;
  EmployeeTab = false;
  filteredPolicy: any;
  filteredApprovals: any;
  filteredRejections: any;
  filteredUpdations: any;
  filteredPayroll:any
  filteredAnnouncements: any;

  selectedTab = 'all';

  leaveReject: any;
  leaveaccept: any;
  rejectedReason = '';
  showRejectBox = false;
  leaveRejectionData: any;
  gettextauto: any;
  activeRejectId: number | null = null;

  constructor(
    private router: Router,
    private addService: AddService,
    private sharedMode: SharedModeService,
    public dashboardService: DashboardService,
    private deviceUuidService: DeviceUuidService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private settings: SettingservicesService,
    private leaveService: LeaveService,

  ) {

  }
  ngOnInit(): void {

    const userInfo = localStorage.getItem('user');
    if (userInfo != null) {
      this.user = JSON.parse(localStorage.getItem('user') || '') || '';
    }
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type == "Admin" || user_role.role_type == "Admin_AND_Team_Lead") {
      this.showAdmintab = true;
      this.EmployeeTab = false;
    } else if (user_role.role_type == "Employee") {
      this.showAdmintab = false;
      this.EmployeeTab = true;
    }
    this.getNotifiations();
    this.isActionPermission();
    this.getTextForAutomation();
  }

  ngAfterViewInit(): void {
    // No longer needed
  }

  switchTab(tab: string): void {
    this.selectedTab = tab;
  }

  private initializeTabs(): void {
    // No longer needed
  }

  isActionPermission() {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    this.leaveaccept = user_role?.leave_data?.data?.values?.accept
    this.leaveReject = user_role?.leave_data?.data?.values?.reject
  }

  toggleRejectBox(leaveId: number) {
    this.rejectedReason = '';
    this.activeRejectId = this.activeRejectId === leaveId ? null : leaveId;
  }
  getTextForAutomation() {
    this.showSpinner = true;
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data;
      this.leaveRejectionData = this.gettextauto.filter((item: any) => item.title.trim() === "LEAVE_REJECTION_TEXT");

      this.showSpinner = false;
    })
  }
  setReason(text: string) {
    this.rejectedReason = text;
  }
  approveleave(data: any) {
    this.showSpinner = true;

    let status;
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      status = 'approved';
    }
    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (data.leave.approval_or_recommendation == 0) {
        status = 'recommended';
      } else if (data.leave.approval_or_recommendation == 1) {
        status = 'approved';
      }
    }

    const raw = data?.data
    const leavedata = JSON.parse(raw);
    const id = leavedata?.type_id
    this.leaveService.getLeaveApproved(id, status).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Approved Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        // window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        // window.location.reload();
      }
      this.showSpinner = false;
    });

  }
  getApprovalButtonLabel(leave: any): string {
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      return 'Approve';
    }

    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (leave.approval_or_recommendation == 0) {
        return 'Recommend';
      } else if (leave.approval_or_recommendation == 1) {
        return 'Approve';
      }
    }

    return 'Approve'; // default fallback
  }
  reject() {
    // let id = this.rejected_leave_id;
    // let rejected_reason = reason.value.rejected_reason;
    const id = this.activeRejectId;
    const rejected_reason = this.rejectedReason;
    this.showSpinner = true;
    this.leaveService.rejectLeave(id, rejected_reason).then((value) => {
      // this.arr[this.rejected_leave_index].status = 'rejected';
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Rejected Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
    });
  }




  getNotifiations() {
    this.showSpinner = true;
    const limit = '';

    this.dashboardService.getNotification(limit)
      .then((value) => {
        this.notifylist = value?.data;
        // this.calculateTotalCount();
        this.totalCount = this.notifylist?.counts
        this.notify_counts = this.notifylist?.counts;
        this.notifyData = this.notifylist?.notifications;
        this.filterLeaveNotifications(['Leave Request', 'Leave Request Edited', 'Leave Request Deleted', 'Rejected Leave', 'Approve Leave', 'Updated Leave']);
        this.filterAttendanceNotifications(['Attendance Correction', 'Approved Attendance', 'Rejected Attendance']);
        this.filterLoanNotifications(['Loan Request', 'Loan Request Edited', 'Loan Request Deleted', 'Rejected Loan', 'Approved Loan']);
        this.filterPolicyNotifications(['Policy Added', 'Policy Edit', 'Policy Deleted']);
        this.filterApproveNotifications(['Approve Leave', 'Approved Loan']);
        this.filterReujectNotifications(['Rejected Leave', 'Rejected Loan']);
        this.filterUpdateNotifications(['Updated Leave'])
        this.filterPayrollNotifications(['Payroll Review Request', 'Payroll Change Requested', 'Payroll Approved']);
        this.filterAnnouncementNotifications(['Announcement']);
      })
      .catch((error) => {
        console.error('Error loading notifications:', error);
      })
      .finally(() => {
        this.showSpinner = false;
      });

  }



  filterLeaveNotifications(reqTypes: string[]): void {
    this.filteredleaves = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }

  filterAttendanceNotifications(reqTypes: string[]): void {
    this.filteredAttendance = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }
  filterLoanNotifications(reqTypes: string[]): void {
    this.filteredLoans = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }

  filterPolicyNotifications(reqTypes: string[]): void {
    this.filteredPolicy = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }

  filterApproveNotifications(reqTypes: string[]): void {
    this.filteredApprovals = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }
  filterUpdateNotifications(reqTypes: string[]): void {
    this.filteredUpdations = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }





  filterReujectNotifications(reqTypes: string[]): void {
    this.filteredRejections = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }

  
  filterPayrollNotifications(reqTypes: string[]): void {
    this.filteredPayroll = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }

  filterAnnouncementNotifications(reqTypes: string[]): void {
    this.filteredAnnouncements = this.notifyData.filter((notifyData: any) => {
      return reqTypes.includes(notifyData.req_type);
    });
  }


  formatDate(dateString: string): string {
    const formattedDate = this.datePipe.transform(dateString, 'hh:mm a | dd MMMM, yyyy');
    return formattedDate ? formattedDate : '';
  }


  formatOnlyDate(dateString: string): string {
    const formattedDate = this.datePipe.transform(dateString, 'dd MMMM, yyyy');
    return formattedDate ? formattedDate : '';
  }

  // calculateTotalCount() {
  //   if (this.notifylist?.counts) {
  //     this.totalCount = Object.values(this.notifylist.counts).reduce((a: any, b: any) => a + b, 0);
  //   }
  // }


  parseJson(jsonString: string): any {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('Error parsing JSON:', e);
      return null;
    }
  }


  clearnotify() {
    this.showSpinner = true;
    this.dashboardService.claerNotifications().then((value) => {
      if (value.success = true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        // this.reloadComponent()
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
          title: 'Get Error in Clear Notifications',
          showConfirmButton: false,
          timer: 3000,
        });
      }
      window.location.reload();
      this.showSpinner = false;
    })
  }


  // reloadComponent() {
  //   const currentUrl = this.router.url;
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate([currentUrl]);
  //   });
  // }

  clearnotifications(notify_id: any) {

    this.showSpinner = true;
    const id = notify_id;
    this.dashboardService.notify(id).then((value) => {

      this.showSpinner = false;
    })
  }
  isavailablefeatureforLeave(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.leave_data?.data?.values;

    switch (type) {
      case "isView":
        return values?.view_leave ?? false;

      case "isAccept":
        return values?.accept ?? false;

      case "isReject":
        return values?.reject ?? false;

      default:
        return false;
    }
  }

}
